module.exports = __webpack_public_path__ + "media/images/session/forget-password-cd8417c1e020be2c3e6b01f0c2f999a8.svg";